import repository from "../Repository";

export default {
  /**
   * 参照API
   * @param {*} screenId 画面ID
   * @param {*} payload ペイロード
   */
  async list(screenId, payload) {
    return await repository.post(`radiation_monitoring_list`, payload, {
      headers: {
        s: screenId
      }
    });
  }
};
